export const Mensaje = ({ mensaje }) => {
    return (
        <div className="flex flex-col gap-4">
            <p className="font-normal text-base text-center">{mensaje}</p>
        </div>
    )
}
